import React, {useEffect, useState} from "react";
import ordersService from "../../../api/services/ordersService";
import {OrdersField} from "../../../constants/Orders/OrdersFields";
import {t} from "i18next";
import NotificationInfo from "./NotificationInfo";
import {IHistoryCurrentNotification} from "../../../redux/notifications/reducer";

interface IOrderNotificationInfoProps {
    currentNotification: IHistoryCurrentNotification,
    data: any
}

interface IOrdersByOrderList {
    id: string,
    externalId: string,
    marketId: string
}

const  OrderNotificationInfo: React.FC<IOrderNotificationInfoProps> = ({data, currentNotification}) => {

    const [order, setOrder] = useState<IOrdersByOrderList[]>([]);

    useEffect(() => {
        if (data.seller) {
            ordersService.getSellerOrdersByOrderList([data.seller], [data.data.orderID], [OrdersField.externalIdField, OrdersField.marketIdField])
                .then(
                    (res) => {
                        if (res.data.success) {
                            const dataOrder =  res.data.data;
                            console.log(111, res)
                            setOrder(dataOrder)
                        } else {
                            setOrder([])
                        }

                    },
                    (err) => {
                        alert(err.message())
                    }
                )
                .catch((err) => {
                    alert(err.message())
                })
        }
    }, []);

    return (
        <>

            <div>
                {order.length !== 0 && data.result
                    ?
                    order.map((item) => {
                        return `Заказ ${t<string>(item.marketId, {ns: "messages"})} №${item.externalId}`;
                    })
                    :
                    `${t<string>('Заказ не найден', {ns: "messages"})}`
                }
            </div>
            <NotificationInfo currentNotification={currentNotification} result={data.result} error={data.error} />
        </>

    )
}

export default  OrderNotificationInfo;